import { render } from "./tender_invitations.vue?vue&type=template&id=7a8aed6c"
import script from "./tender_invitations.vue?vue&type=script&lang=js"
export * from "./tender_invitations.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/create/tabs/tender_invitations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a8aed6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a8aed6c', __exports__)) {
    console.log('reload')
    api.reload('7a8aed6c', __exports__)
  }
  
  module.hot.accept("./tender_invitations.vue?vue&type=template&id=7a8aed6c", () => {
    console.log('re-render')
    api.rerender('7a8aed6c', render)
  })

}


export default __exports__